import styled from "styled-components";
import { ThemeButton } from "@sc/custom.styled";

export const FormContainer = styled.form`
  padding: 28px;
  background: linear-gradient(180deg, #fffdf9 0%, #ffffff 100%);
  border-radius: 10px;
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const FormTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.78);
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  font-size: 13px;
  letter-spacing: 0.01em;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  box-sizing: border-box;
  background: #fff;
  color: rgba(0, 0, 0, 0.78);

  &::placeholder {
    color: rgba(0, 0, 0, 0.32);
  }

  &:focus {
    border-color: #ff8a23;
    box-shadow: 0 0 0 3px rgba(255, 138, 35, 0.14);
    outline: none;
  }
`;

export const SectionLabel = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`;

export const SubmitButton = styled(ThemeButton)`
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;

  &:disabled {
    background-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  box-sizing: border-box;
  background: #fff;
  color: rgba(0, 0, 0, 0.78);
  font-family: monospace;
  font-size: 12px;
  resize: vertical;
  min-height: 120px;

  &::placeholder {
    color: rgba(0, 0, 0, 0.32);
    font-family: monospace;
  }

  &:focus {
    border-color: #ff8a23;
    box-shadow: 0 0 0 3px rgba(255, 138, 35, 0.14);
    outline: none;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
  background: #f5f5f5;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 6px 12px;

  input[type="checkbox"] {
    cursor: pointer;
    accent-color: #ff8a23;
    width: 14px;
    height: 14px;
  }
`;

export const ErrorText = styled.div`
  color: #cf1322;
  background: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  margin: 12px 0 0;
`;
